export type AssistantPanelVariant = "side" | "floating" | "fullscreen";

export type AssistantPanelFloatingPosition = {
  x: number;
  y: number;
};

export type AssistantPanelFloatingSize = {
  width: number;
  height: number;
};

export enum AssistantPanelView {
  CHAT = "chat",
  LEARN = "learn",
}
